export function validaCelular(cell: string) {
  if (/^\d+(?:\.\d+)?$/.test(cell) && (cell.length == 11 || cell.length == 10))
    return true;

  return false;
}
